if (process.env.NODE_ENV === 'development') {
  // @ts-ignore dev-only dependency, not installed in CI prod builds
  import('react-grab')
}

import 'core-js/es'
// Touch DnD polyfill for MapViewsSidebarListItem reorder inside the mobile drawer.
import 'drag-drop-touch'
// Must precede shadcn.css so the Inter @font-face is in scope.
import '@fontsource-variable/inter'
import '@fontsource-variable/inter/wght-italic.css'
import '~/client/src/shared/shadcn.css'
import '~/client/src/shared/tailwind.css'
import '../shared/vendor-mapbox.css'
import '../shared/vendor.css'
import './mobile.css'
import * as React from 'react'

import * as Sentry from '@sentry/browser'
import { render } from 'react-dom'

import MobileRoutes from '~/client/src/mobile/mobile.routes'
import config from '~/client/src/shared/Config'
import {
  COLLECT_TELEMETRY,
  LISTEN_TO_DEPLOYMENT_VERSION,
  NO_EFFECT,
  START_ALL,
} from '~/client/src/shared/stores/EventStore/eventConstants'
import EventContext from '~/client/src/shared/stores/EventStore/EventContext'

import App from '../shared/App'
import AppProvider from '../shared/components/AppProvider'
import Config from '../shared/Config'
import Localization from '../shared/localization/LocalizationManager'
import loadFidhubWidget from '../shared/utils/fidhubWidget'
import { beforeSend } from '../shared/utils/Sentry'
import ThemeMode from '../shared/utils/ThemeModeManager'
import Container from './container'

/* eslint-disable zoomin/scss-import-last */
import '~/client/src/shared/tones.scss'
import '../shared/styles.scss'

const eventsToHideInLog = [COLLECT_TELEMETRY, NO_EFFECT]

function startApp() {
  const environment = config.ENVIRONMENT.toLowerCase()
  const isSentryEnabled = ['qa', 'staging', 'production'].includes(environment)

  if (isSentryEnabled) {
    Sentry.init({
      beforeSend,
      dsn: 'https://c4509968fb074001bfefc1902752cee6@sentry.io/1819303',
      environment: config.ENVIRONMENT,
      release: `StruxHub-Mobile@${config.VERSION}`,
      attachStacktrace: true,
    })
  }

  Localization.init()

  new App(Config).configure()
  loadFidhubWidget()

  const isTestEnv = ['qa', 'development'].includes(
    config.ENVIRONMENT.toLowerCase(),
  )
  const container = new Container(isTestEnv)
  const { rootStore } = container
  const { eventsStore } = rootStore

  ThemeMode.init()

  if (isTestEnv) {
    window.stores = rootStore
    eventsStore.addPostEventCallback(({ event }: EventContext) => {
      const [type] = event
      if (eventsToHideInLog.includes(type)) {
        return
      }

      console.groupCollapsed(type)

      console.groupEnd()
    })
  }

  eventsStore.dispatch(START_ALL, () => {
    render(
      <AppProvider
        rootStore={rootStore}
        // Clears BottomNavigationNavBar (60px + safe area) plus a 16px gap.
        toastViewportClassName="tw:bottom-[calc(76px_+_env(safe-area-inset-bottom))]"
      >
        <MobileRoutes />
      </AppProvider>,
      document.getElementById('app'),
    )
  })

  eventsStore.dispatch(LISTEN_TO_DEPLOYMENT_VERSION)
}

config.READY.then(startApp)
